// CarouselSteps.js
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

const data = [
  {
    step: 1,
    title: 'Enter Your Details',
    description: 'Fill in your personal information to begin.'
  },
  {
    step: 2,
    title: 'Choose a Template',
    description: 'Select a biodata design from our curated list of templates.'
  },
  {
    step: 3,
    title: 'Get Biodata on WhatsApp',
    description: 'Enter your number and get your Biodata PDF on WhatsApp.'
  },
  {
    step: 4,
    title: 'Share with Family',
    description: 'Easily share your biodata with your loved ones.'
  },
  {
    step: 5,
    title: 'Print or Email',
    description: 'Download or send your biodata directly.'
  }
];

// Custom Arrows
const NextArrow = ({ onClick }) => (
  <div className="custom-arrow next-arrow" onClick={onClick}>
    <FaArrowRight />
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="custom-arrow prev-arrow" onClick={onClick}>
    <FaArrowLeft />
  </div>
);

const CarouselSteps = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {data.map((item, index) => (
          <div style={{marginLeft:"20px"}} key={index} className="carousel-card">
            <div className="step-circle">{item.step}</div>
            <h1 style={{color:"black"}}>{item.title}</h1>
            <p style={{color:"#571212"}}>{item.description}</p>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default CarouselSteps;
